/* Visivio — pole głębi na całą stronę.
   Ta sama geometria co dawna warstwa 3D w hero (falująca siatka punktów,
   WebGL bez biblioteki), ale zamiast siedzieć tylko w hero, leży teraz
   przypięta pod całą stroną. Rysuje się tylko wtedy, kiedy karta jest
   widoczna, zwalnia poza pierwszym ekranem i całkiem odpuszcza przy
   prefers-reduced-motion albo braku WebGL — strona wygląda wtedy tak samo,
   po prostu bez ruchu.

   Nazwa klasy: płótno dostaje .vv-field i siedzi zawsze jako pierwsze
   dziecko <body>. Ta sama nazwa oznacza w vv2.css opakowanie pola
   formularza, dlatego i tu, i w vv-renew.css wszystko jest zawężone do
   "body > .vv-field". */
(function () {
  'use strict';
  if (window.__vvField) return;
  window.__vvField = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (reduce) return;

  var VS = [
    'attribute vec2 aGrid;',
    'uniform float uTime;',
    'uniform vec2 uPointer;',
    'uniform float uAspect;',
    'uniform float uSize;',
    'varying float vFade;',
    'void main(){',
    '  float x = aGrid.x;',
    '  float z = aGrid.y;',
    '  float y = sin(x*1.7 + uTime*0.34)*0.45 + cos(z*1.35 - uTime*0.25)*0.45;',
    '  y += sin((x+z)*0.9 + uTime*0.17)*0.18;',
    '  vec3 p = vec3(x + uPointer.x*0.10, y + uPointer.y*0.05 - 1.9, z + 2.55);',
    '  float persp = 1.0 / max(p.z, 0.12);',
    '  gl_Position = vec4(vec2(p.x * persp / uAspect, p.y * persp), 0.0, 1.0);',
    '  float depth = clamp(1.0 - (p.z - 2.4) / 4.2, 0.0, 1.0);',
    '  vFade = depth * depth * (0.5 + 0.5 * smoothstep(-0.35, 0.45, y));',
    '  gl_PointSize = max(uSize * persp * 1.5, 1.0);',
    '}'
  ].join('\n');

  var FS = [
    'precision mediump float;',
    'varying float vFade;',
    'uniform vec3 uCol;',
    'void main(){',
    '  vec2 c = gl_PointCoord - vec2(0.5);',
    '  float d = dot(c, c);',
    '  if (d > 0.25) discard;',
    '  float soft = smoothstep(0.25, 0.02, d);',
    '  gl_FragColor = vec4(uCol, soft * vFade * 0.85);',
    '}'
  ].join('\n');

  function compile(gl, type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { gl.deleteShader(s); return null; }
    return s;
  }

  function start() {
    if (document.querySelector('body > .vv-field')) return;

    var host = document.createElement('div');
    host.className = 'vv-field';
    host.setAttribute('aria-hidden', 'true');
    var canvas = document.createElement('canvas');
    host.appendChild(canvas);

    var gl = null;
    try {
      gl = canvas.getContext('webgl', { alpha: true, antialias: true, depth: false, premultipliedAlpha: false })
        || canvas.getContext('experimental-webgl', { alpha: true, antialias: true, depth: false });
    } catch (e) { gl = null; }
    if (!gl) return;

    var vs = compile(gl, gl.VERTEX_SHADER, VS);
    var fs = compile(gl, gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return;
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;

    document.body.insertBefore(host, document.body.firstChild);
    document.documentElement.classList.add('vv-field-on');

    var small = window.innerWidth < 900;
    var COLS = small ? 44 : 74;
    var ROWS = small ? 24 : 34;
    var COUNT = COLS * ROWS;
    var data = new Float32Array(COUNT * 2);
    var k = 0;
    for (var r = 0; r < ROWS; r++) {
      for (var c = 0; c < COLS; c++) {
        data[k++] = (c / (COLS - 1) - 0.5) * 7.6;
        data[k++] = (r / (ROWS - 1)) * 4.3;
      }
    }

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);

    gl.useProgram(prog);
    var aGrid = gl.getAttribLocation(prog, 'aGrid');
    gl.enableVertexAttribArray(aGrid);
    gl.vertexAttribPointer(aGrid, 2, gl.FLOAT, false, 0, 0);

    var uTime = gl.getUniformLocation(prog, 'uTime');
    var uPointer = gl.getUniformLocation(prog, 'uPointer');
    var uAspect = gl.getUniformLocation(prog, 'uAspect');
    var uSize = gl.getUniformLocation(prog, 'uSize');

    var col = window.vvAccentRGB ? window.vvAccentRGB([0.376, 0.647, 0.980]) : [0.376, 0.647, 0.980];
    gl.uniform3f(gl.getUniformLocation(prog, 'uCol'), col[0], col[1], col[2]);

    gl.disable(gl.DEPTH_TEST);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE);

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var W = host.clientWidth, H = host.clientHeight;
      canvas.width = Math.floor(W * dpr);
      canvas.height = Math.floor(H * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform1f(uAspect, Math.max(W / Math.max(H, 1), 0.3));
      gl.uniform1f(uSize, (small ? 10 : 13) * dpr);
    }
    resize();
    window.addEventListener('resize', resize);

    /* Kursor przesuwa pole delikatnie; bez kursora robi to scroll. */
    var px = 0, py = 0, tx = 0, ty = 0;
    if (fine) {
      window.addEventListener('pointermove', function (e) {
        tx = (e.clientX / window.innerWidth - 0.5) * 2;
        ty = (e.clientY / window.innerHeight - 0.5) * 2;
      }, { passive: true });
    } else {
      window.addEventListener('scroll', function () {
        /* Na telefonie polem steruje vv-mobile.js (scroll + żyroskop) przez
           vvField.setPointer. Gdyby oba pisały naraz, pole drżałoby przy
           przewijaniu — więc ta ścieżka wyłącza się, gdy tamten skrypt żyje. */
        if (window.__vvMobile) return;
        var h = Math.max(document.body.scrollHeight - window.innerHeight, 1);
        ty = (window.pageYOffset / h - 0.5) * 1.6;
      }, { passive: true });
    }
    window.vvField = {
      setPointer: function (x, y) {
        if (typeof x === 'number') tx = Math.max(-1.5, Math.min(x, 1.5));
        if (typeof y === 'number') ty = Math.max(-1.5, Math.min(y, 1.5));
      }
    };

    var running = true, raf = null, t0 = null, last = 0;
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running && !raf) raf = requestAnimationFrame(draw);
    });

    function draw(ts) {
      raf = null;
      if (!running) return;
      if (!t0) t0 = ts;
      /* Poniżej pierwszego ekranu pole i tak jest ledwie widoczne —
         wtedy rysujemy je co drugą klatkę, żeby nie zjadać baterii. */
      var deep = window.pageYOffset > window.innerHeight * 1.2;
      if (!deep || ts - last > 32) {
        last = ts;
        px += (tx - px) * 0.04;
        py += (ty - py) * 0.04;
        gl.uniform1f(uTime, (ts - t0) / 1000);
        gl.uniform2f(uPointer, px, py);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.POINTS, 0, COUNT);
      }
      raf = requestAnimationFrame(draw);
    }
    raf = requestAnimationFrame(draw);
    requestAnimationFrame(function () { host.classList.add('is-live'); });

    window.addEventListener('pagehide', function () {
      if (raf) cancelAnimationFrame(raf);
      running = false;
      try {
        gl.deleteBuffer(buf); gl.deleteProgram(prog);
        gl.deleteShader(vs); gl.deleteShader(fs);
        var lose = gl.getExtension('WEBGL_lose_context');
        if (lose) lose.loseContext();
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
